import { ReactNode } from 'react';
import { useSettingsContext } from '@/contexts/SettingsContext';

interface PermissionGateProps {
  permission: string;
  children: ReactNode;
  fallback?: ReactNode;
}

/**
 * PermissionGate - Conditionally render children based on user permissions
 */
export function PermissionGate({ permission, children, fallback = null }: PermissionGateProps) {
  const { permissions } = useSettingsContext();

  const hasPermission = permissions.includes(permission) || permissions.includes('platform.all');

  if (!hasPermission) {
    return <>{fallback}</>;
  }

  return <>{children}</>;
}
